export default "__VITE_ASSET__96d5d6bb__"